import { render, staticRenderFns } from "./UserPlanMessage.vue?vue&type=template&id=73dc6a34"
import script from "./UserPlanMessage.vue?vue&type=script&lang=js"
export * from "./UserPlanMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports